/**
 * AntragEinreichenDialog - «Einreichen» (Tab 5a, P2 Slice 13). Confirms the carrier address + the
 * signed-file beilage before the mail goes out.
 */

import {
  ANTRAG_CARRIER_EMAIL_FEHLT_HINWEIS,
  ANTRAG_EINREICHEN_BESTAETIGUNG,
  type AntragResponse,
} from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

const ERROR_TEXT: Record<string, string> = {
  versand_unterbrochen: 'Versand unterbrochen - bitte zuerst aufloesen',
  carrier_email_fehlt: ANTRAG_CARRIER_EMAIL_FEHLT_HINWEIS,
  mailbox_not_connected: 'Keine Mailbox verbunden - bitte zuerst unter Einstellungen verbinden',
  communication_send_required: 'Keine Berechtigung zum Versand von E-Mails',
  versand_laeuft: 'Versand laeuft - bitte warten',
  dokument_unavailable: 'Der unterschriebene Antrag ist nicht verfuegbar',
};

export function AntragEinreichenDialog({
  open,
  onClose,
  facts,
  onEinreichen,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  facts: AntragResponse;
  onEinreichen: () => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const errorText = error?.code ? (ERROR_TEXT[error.code] ?? 'Einreichen fehlgeschlagen') : null;
  const signiert = facts.antrag?.signiert ?? null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Antrag einreichen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving || facts.carrier_email === null} onClick={() => onEinreichen()} data-testid="antrag-einreichen-submit">
            Einreichen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="antrag-einreichen-dialog">
        {facts.carrier_email === null ? (
          <p className="text-status-danger">{ANTRAG_CARRIER_EMAIL_FEHLT_HINWEIS}</p>
        ) : (
          <p>
            An {facts.antrag?.carrier_name ?? facts.antrag?.carrier_uid} ({facts.carrier_email})
          </p>
        )}
        {signiert && (
          <p className="text-muted-foreground">
            Beilage: {signiert.filename} ({Math.max(1, Math.round(signiert.size_bytes / 1024))} KB)
          </p>
        )}
        <p role="note" className="text-xs text-muted-foreground">{ANTRAG_EINREICHEN_BESTAETIGUNG}</p>
        {errorText && <p className="text-sm text-status-danger" data-testid="antrag-einreichen-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
